<script setup lang="ts">
/** 控制骨架卡片数量，默认与关联员工列表首屏数量一致。 */
const props = withDefaults(
  defineProps<{
    count?: number
  }>(),
  {
    count: 6,
  },
)
</script>

<template>
  <div
    class="grid grid-cols-1 gap-x-[24px] gap-y-[25px] pt-[20px] min-[800px]:grid-cols-2 min-[1200px]:grid-cols-3"
    aria-hidden="true"
  >
    <article
      v-for="index in props.count"
      :key="`employee-skeleton-${index}`"
      class="flex min-w-0 flex-col gap-[12px] rounded-[8px] p-[8px]"
    >
      <div class="flex min-w-0 items-start gap-[12px]">
        <span class="size-[40px] shrink-0 animate-pulse rounded-full bg-[#F1F2F4]" />
        <div class="flex min-w-0 flex-1 flex-col gap-[6px] pt-[2px]">
          <span class="h-[20px] w-[44%] animate-pulse rounded-[4px] bg-[#F1F2F4]" />
          <span class="h-[14px] w-[72%] animate-pulse rounded-[4px] bg-[#F1F2F4]" />
        </div>
      </div>

      <div class="h-[120px] flex min-w-0 flex-col gap-[12px] rounded-[8px] border border-[rgba(5,21,36,0.06)] bg-white p-[16px]">
        <div class="grid grid-cols-2 gap-[4px] border-b-[0.5px] border-[rgba(5,21,36,0.06)] pb-[12px]">
          <div class="flex flex-col gap-[8px]">
            <span class="h-[16px] w-[56%] animate-pulse rounded-[4px] bg-[#F1F2F4]" />
            <span class="h-[18px] w-[76%] animate-pulse rounded-[4px] bg-[#F1F2F4]" />
          </div>
          <div class="flex flex-col gap-[8px]">
            <span class="h-[16px] w-[52%] animate-pulse rounded-[4px] bg-[#F1F2F4]" />
            <span class="h-[18px] w-[68%] animate-pulse rounded-[4px] bg-[#F1F2F4]" />
          </div>
        </div>
        <div class="flex items-center gap-[8px]">
          <span class="size-[16px] shrink-0 animate-pulse rounded-[2px] bg-[#F1F2F4]" />
          <span class="h-[14px] w-[48%] animate-pulse rounded-[4px] bg-[#F1F2F4]" />
        </div>
      </div>
    </article>
  </div>
</template>
